import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './header';
import Footer from './footer';

function WebLayout() {
  return (
    <Box>
      <Header />
      <Box
        component={"main"}
        sx={{
          height: "100%"
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  )
}

export default WebLayout